import React from 'react'
import { Component } from 'react';
import axios from 'axios';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import { nameRegex, postalCodeRegex } from '../../../../shared/helper.js';
import GlobalMainSearchInstitutionsJsx from './globalMainSearchInstitutions.jsx'

export default class GlobalMainSearchInstitutions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            subCategoryData: null,
            formData: {
                name: '',
                postalCode: '',
                category: null,
                subCategory: null,
                keyword: ''
            },
            oldest: false,
            selectedCategoryId: null,
            subCategories: [],
            categories: [],
            checkedCats: [],
            checkedSubCats: [],

            investmentOfferData: null,
            allOffersData: null,
            overallOffers: null,
            topOffers: null,
            mortgageOfferData: null,
            insuranceOfferData: null,
            bankingOfferData: null,
            realestateOfferData: null,
            isProcessing: false,
            formError: {},
            formSubmitButtonDisable: true,
            isLoading: false,
            selectAll: false,
            expertData: [],
            page: 1,
            totalSubCategories: "",
            disableSelectAll : true
        }
    }
   

    componentDidMount = () => {
        const categoryIdFromPev = localStorage.getItem("selectCategory");

        this.getTopOffers();

        this.getcategorySubcategory(true);
        setTimeout(() => {
            categoryIdFromPev ? this.checkCategoryFromPrevious() : this.selectAllIds()


        }, 1000);
        this.props.match.params.keyword && this.fetchSearchData(this.props.match.params.keyword);


    }

    getcategorySubcategory = (firstFetch=false) => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ categoryData: res.data.data, isLoading: false })
              // Calculate the total number of subInstitutionCategories
              const totalSubCategories = this.state.categoryData?.reduce((acc, category) => {
                return acc + (category.subInstitutionCategories ? category.subInstitutionCategories.length : 0);
            }, 0);

            // Set the totalSubCategories in state
            this.setState({ totalSubCategories });
        }).then(res => {
            if(firstFetch)
            {
                this.selectAllIds()
            }
        })
    }
    getAllFeauturedOffersData = () => {
        const selectedType = this.props.match.params.type;
        this.setState({ isProcessing: true })
        // for offer button click
        if (selectedType === "all") {
            axios.get(`${baseURL}/search-offers`).then(res => {

                this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            })
        } else if (selectedType === "homeFeatured") {

            axios.get(`${baseURL}/homeFeaturedOffers`).then(res => {

                this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            })
        } else {
            axios.get(`${baseURL}/FeaturedOffers?institutionCategoryId=${selectedType}`).then(res => {

                this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            })
        }

    }
    checkCategoryFromPrevious = () => {
        const categoryIdFromPev = localStorage.getItem("selectCategory");
        this.setState({ selectAll: false })
        if (categoryIdFromPev) {
            // Find the category in categoryData that matches the category ID 
            const selectedCategory = this.state.categoryData.find(

                category => category.institutionCategoryId.toString() === categoryIdFromPev

            );


            if (selectedCategory) {
                // Select this category and its subcategories
                this.selectCategory1(selectedCategory);
            }
        }
    }
    selectCategory1 = (selectedCategory) => {
        const institutionCategoryIds = selectedCategory.subInstitutionCategories.map(subCategory => subCategory.institutionCategoryId);

        // Add the category and its subcategories to the state
        this.setState(prevState => ({
            subCategories: [...prevState.subCategories, ...institutionCategoryIds],
            categories: [...prevState.categories, selectedCategory.institutionCategoryId]
        }));

        // Optionally trigger a filtering or update
        setTimeout(() => {
            this.filterCatData();
        }, 500);
    }
    selectAllHit = (e) => {
        const { checked } = e.target
        if (!checked) {
            this.setState({ selectAll: false })
        } else {
            this.setState({ selectAll: true })

        }
        if (checked) {
            this.setState({ allOffersData: this.state.overallOffers, keyword: "",disableSelectAll:true })
            this.selectAllIds()


        }


    }

    searchOfferByKeyword = (e) => {
        const data = e.target.value
        this.setState({ keyword: data })
    }

    hitSearch = () => {
        this.props.history.replace('/')
        this.props.history.push(`/offers/${this.props.match.params.type}/${this.state.keyword}`)
        this.fetchSearchData(this.state.keyword)
        this.selectAllIds()
    }

    fetchSearchData = (data) => {

        axios.get(`${baseURL}/search-content?keyword=${data}`).then(res => {
            this.setState({ allOffersData: res.data.data.offers, overallOffers: res.data.data.offers, isProcessing: false })
            document.querySelector(".sortingdiv").scrollIntoView();
        })
    }

    hitOldest = (action) => {
        // this.setState(
        //     {
        //         formData: {
        //             ...this.state.formData,
        //             'name': '',
        //             'postalCode':''

        //         }
        //     }
        // )
        let { name, postalCode } = this.state.formData

        this.setState({ oldest: action, isProcessing: true, page: 1 })
        this.props.history.replace('/')
        this.props.history.push(`/globalMainSearchInstitutions`)
        setTimeout(() => {
            if (name || postalCode) {
                this.onSubmitButtonClick()
            } else {
                this.getTopOffers()
            } this.selectAllIds()
        }, 500);
    }

    getTopOffers = () => {
        const queryString = window.location.search; // Get the query string
        const urlParams = new URLSearchParams(queryString); // Create URLSearchParams object
        const searchValue = urlParams.get('search') || "";
        this.setState({ isProcessing: true })
        axios.get(`${baseURL}/search-global-institutes?search=${searchValue}&page=1&perPage=100000&sortOrder=${this.state.oldest ? "desc" : "asc"}`).then(res => {
            this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            // Get the current URL hash
            const hash = window.location.hash;

            // Check if the desired hash link is present
            if (hash !== '') {
                // scroll to section
                const element = document.getElementById(hash.replace('#', ''));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        })
    }


    onCatgoryClick = (value) => {
        const subData = this.state.categoryData.filter(itm => itm.institutionCategoryId === Number(value))

        this.setState({ subCategoryData: subData[0]?.subInstitutionCategories })
    }
    isFromSubmissionBlock = () => {
        let { postalCode, name } = this.state.formData;

        if (postalCode || name) {
            if (this.inputRegexValidation("name", name) || this.inputRegexValidation("postalCode", postalCode)
            )
                this.setState({
                    formSubmitButtonDisable: false
                });

            else
                this.setState({
                    formSubmitButtonDisable: true
                });
        } else {
            this.setState({
                formSubmitButtonDisable: true
            });
        }
    };
    onInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (name === 'category') {
            this.onCatgoryClick(value)
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        'subCategory': '',
                    }
                }
            )

        }


        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            } else {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            }
        } else {
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    }
    inputRegexValidation = (name, value) => {
        if (name === 'name')
            return nameRegex.test(value);
        if (name === 'postalCode')
            return postalCodeRegex.test(value);

        return true;
    };

    onSubmitButtonClick = () => {
        this.setState({ isProcessing: true });
        this.setState({ page: 1 })
        this.selectAllIds()
        const { name, postalCode } = this.state.formData;
        axios.get(`${baseURL}/filter-institutes?page=1&perPage=99999&name=${name}&postalCode=${postalCode}&sortBy=${this.state.oldest ? "desc" : "asc"}`).then(res => {
            this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
        }).catch(err => {
            this.setState({ isProcessing: false });
            console.warn(err?.response.data.error.message);
        })
    }
    onSubmitButtonClick1 = () => {
        this.setState(
            {
                formData: {
                    ...this.state.formData,
                    'name': '',
                    'postalCode': ''
                }, page: 1
            }
        )
        this.getTopOffers()
        this.selectAllIds()
    }

    // filter all selected id
    selectAllIds = () => {
        localStorage.removeItem("selectCategory")
        const institutionCategoryIds = this.state.categoryData?.map(category => category.institutionCategoryId);
        this.setState({ categories: institutionCategoryIds })

        // Extract sub-institution category IDs as well
        this.state.categoryData?.forEach(category => {
            if (category?.subInstitutionCategories) {
                const subIds = category?.subInstitutionCategories?.map(subCategory => subCategory.institutionCategoryId);
                // institutionCategoryIds.push(...subIds);
                this.setState(prevState => ({
                    subCategories: [...prevState.subCategories, ...subIds] // Spread existing items and add new items
                }));
                // this.setState({ subCategories: ...subIds })

            }
        });

        this.setState({ institutionCategoryIds });
    }


    filterCatData = () => {

        const catDataFiltered = this.state.overallOffers.filter(offer => {
            return offer.instituteCategories.some(specialization =>
                specialization.institutionCategoryId && this.state.categories.includes(specialization.institutionCategoryId)
            );
        }
        );
        this.setState({ allOffersData: catDataFiltered })
        if (this.state.subCategories.length === 0) {
            this.setState({ allOffersData: this.state.overallOffers, selectAll: true })
            this.selectAllIds()

        }


    }

    filterSubData = () => {

        const subCatDataFiltered = this.state.overallOffers.filter(offer => {
            // Check if any of the expertSpecializations have a matching institutionSubCategoryId
            return offer.expertSpecializations.some(specialization =>
                specialization.expertSpecializationSubCategories &&
                specialization.expertSpecializationSubCategories.some(subCat =>
                    this.state.subCategories.includes(subCat.institutionSubCategoryId)
                )
            );
        });


        this.setState({ allOffersData: subCatDataFiltered })
        if (this.state.subCategories.length === 0) {
            this.setState({ allOffersData: this.state.overallOffers, selectAll: true })
            this.selectAllIds()

        }

    }
    selectCategory = (data, e) => {
        localStorage.removeItem("selectCategory")
        localStorage.setItem("changing", true)
        const { checked } = e.target
        this.setState({ selectAll: false,disableSelectAll:false })
        this.triggerSelectAll()        // 
        const selectedId = data.institutionCategoryId;
        this.setState({ selectedCategoryId: selectedId });
        const selectedCategory = this.state.categoryData.find(category => category.institutionCategoryId === selectedId);
        if (selectedCategory) {
            const insInsideCat = selectedCategory.subInstitutionCategories
            const institutionCategoryIds = insInsideCat.map(category => category.institutionCategoryId);
            if (checked) {
                this.setState((prevState) => ({
                    subCategories: [...prevState.subCategories, ...institutionCategoryIds],
                }));
                this.setState({ page: 1 })


            } else {

                this.setState((prevState) => ({
                    subCategories: prevState.subCategories.filter(
                        (id) => !institutionCategoryIds.includes(id) // Remove IDs present in newIds
                    )
                }));
                this.setState({ page: 1 })
            }
        } else {
            this.setState({ subCategories: [] });
        }
        setTimeout(() => {
            this.filterCatData()

        }, 500);


        this.setState((prevState) => {
            const { categories } = prevState;

            // Check if the id is already in the categories
            if (categories.includes(data.institutionCategoryId)) {
                // Remove the id
                return { categories: categories.filter(selectedId => selectedId !== data.institutionCategoryId) };
            } else {
                // Add the id
                return { categories: [...categories, data.institutionCategoryId] };
            }
        });
    }


    handleCheckboxChange = (id) => (event) => {
        if (event.target.checked) {
            // Add ID to the selected array if not already present
            this.setState((prevState) => ({
                selectedIds: prevState.selectedIds.includes(id)
                    ? prevState.selectedIds
                    : [...prevState.selectedIds, id]
            }));
        } else {
            // Remove ID from the selected array when unchecked
            this.setState((prevState) => ({
                selectedIds: prevState.selectedIds.filter((selectedId) => selectedId !== id)
            }));
        }
    };













    selectSubCategory = (data) => {
        localStorage.removeItem("selectCategory")
        localStorage.setItem("changing", true)
        this.setState({ selectAll: false,disableSelectAll:false })

        this.triggerSelectAll()
        this.setState((prevState) => {
            if (prevState.subCategories.includes(data.institutionCategoryId)) {
                // If the ID is already selected, remove it
                return { subCategories: prevState.subCategories.filter((prevId) => prevId !== data.institutionCategoryId) };
            } else {
                // If the ID is not selected, add it
                return { subCategories: [...prevState.subCategories, data.institutionCategoryId] };
            }
        });

        setTimeout(() => {
            this.filterSubData()

        }, 500);

        // console.warn("selected sub cat", data,this.state.checkedCats)

    }
    onPaginationButtonClick = (page) => {
        document.querySelector(".sortingdiv").scrollIntoView();
        this.setState({ page: page })
    }

    triggerSelectAll = () => {
        setTimeout(() => {
            const uniqueData = new Set(this.state.subCategories);

            // Get the length of the unique data
            const uniqueCount = uniqueData.size;

            if (uniqueCount >= this.state.totalSubCategories) {
                this.setState({ selectAll: true })
            }
            if(uniqueCount ===  this.state.totalSubCategories){
                this.setState({ disableSelectAll: true })

            }
        }, 500);

    }
    render() {
        return (
            <div>
                <GlobalMainSearchInstitutionsJsx
                    subCategories={this.state.subCategories}
                    categories={this.state.categories}
                    searchOfferByKeyword={this.searchOfferByKeyword}
                    hitSearch={this.hitSearch}
                    selectAllHit={this.selectAllHit}
                    getAllFeauturedOffersData={this.getAllFeauturedOffersData}
                    investmentOfferData={this.state.investmentOfferData}
                    topOffers={this.state.topOffers}
                    mortgageOfferData={this.state.mortgageOfferData}
                    insuranceOfferData={this.state.insuranceOfferData}
                    bankingOfferData={this.state.bankingOfferData}
                    realestateOfferData={this.state.realestateOfferData}
                    allOffersData={this.state.allOffersData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    page={this.state.page}
                    formSubmitButtonDisable={this.state.formSubmitButtonDisable}

                    categoryData={this.state.categoryData}
                    subCategoryData={this.state.subCategoryData}
                    formData={this.state.formData}
                    onInputChange={this.onInputChange}
                    formError={this.state.formError}
                    onSubmitButtonClick={this.onSubmitButtonClick}
                    onSubmitButtonClick1={this.onSubmitButtonClick1}
                    closFunction={this.closeFunction}
                    selectCategory={this.selectCategory}
                    selectSubCategory={this.selectSubCategory}
                    selectAll={this.state.selectAll}
                    oldest={this.state.oldest}
                    hitOldest={this.hitOldest}
                    disableSelectAll={this.state.disableSelectAll}

                />
                {this.state.isProcessing && <Loader />}
            </div>
        )
    }
}